// Which servers this browser notifies about. A preference of the device, not of the account: one phone can
// follow every server while each desktop Chrome profile (one per client) follows only its own. Kept in
// localStorage; when storage is unavailable the default (all servers) applies.

export interface NotificationPrefs {
  scope: 'all' | 'servers';
  servers: string[];
}

const KEY = 'aidev.notifications.v1';
const DEFAULT: NotificationPrefs = { scope: 'all', servers: [] };
export const PREFS_EVENT = 'aidev-notification-prefs';

export function loadPrefs(): NotificationPrefs {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return DEFAULT;
    const p = JSON.parse(raw) as Partial<NotificationPrefs>;
    if (p.scope !== 'all' && p.scope !== 'servers') return DEFAULT;
    return { scope: p.scope, servers: Array.isArray(p.servers) ? p.servers.filter((s): s is string => typeof s === 'string') : [] };
  } catch {
    return DEFAULT;
  }
}

export function savePrefs(prefs: NotificationPrefs): void {
  try {
    localStorage.setItem(KEY, JSON.stringify(prefs));
  } catch {
    // Private window or blocked storage: the choice lasts for this page only
  }
  window.dispatchEvent(new Event(PREFS_EVENT));
}

/** Events without a server (account-wide, e.g. the cost alert) are always shown */
export function followsServer(prefs: NotificationPrefs, serverId: string | undefined): boolean {
  return prefs.scope === 'all' || !serverId || prefs.servers.includes(serverId);
}
